"use client";

import { useEffect, useRef, useState } from "react";

/**
 * CopyEmailButton — 이메일 주소를 클립보드에 복사하고 잠시 "Copied!" 로 확인한다.
 *   mailto 가 통하지 않는 환경(웹메일 사용자, 메일 앱 미설정)의 대안 경로.
 */
export function CopyEmailButton({ email }: { email: string }) {
  const [copied, setCopied] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const resetTimer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(resetTimer.current), []);

  async function copyEmail() {
    try {
      await navigator.clipboard.writeText(email);
    } catch {
      // 클립보드 API 가 막힌 브라우저(비보안 컨텍스트 등) 폴백.
      const textarea = document.createElement("textarea");
      textarea.value = email;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      textarea.remove();
      // textarea.select() 가 가져간 키보드 포커스를 버튼으로 되돌린다.
      buttonRef.current?.focus();
    }
    setCopied(true);
    window.clearTimeout(resetTimer.current);
    resetTimer.current = window.setTimeout(() => setCopied(false), 2000);
  }

  return (
    <button
      ref={buttonRef}
      type="button"
      onClick={copyEmail}
      className="rounded-full border border-white/60 px-6 py-3 text-center text-lg font-semibold text-white transition-colors hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
    >
      {/* 두 라벨을 같은 그리드 셀에 겹쳐 넣어 라벨이 바뀌어도 버튼 폭이 흔들리지 않게 한다. */}
      <span aria-live="polite" className="grid">
        <span className={`col-start-1 row-start-1 ${copied ? "invisible" : ""}`}>
          Copy address
        </span>
        <span className={`col-start-1 row-start-1 ${copied ? "" : "invisible"}`}>
          Copied!
        </span>
      </span>
    </button>
  );
}
